import { useQuery } from "@tanstack/react-query";
import { fetchCaptains, transformCMSCaptainToAppCaptain } from "../services/captains";
import { QUERY_CONSTANTS } from "../constants/query-constants";
import { CaptainsData } from "../types/CMS";
import { useMemo } from "react";

export const useCaptainsData = () => {
    return useQuery<CaptainsData>({
        queryKey: ["captains"],
        queryFn: fetchCaptains,
        staleTime: QUERY_CONSTANTS.STALE_TIME,
        refetchInterval: QUERY_CONSTANTS.REFETCH_INTERVAL,
    });
};

export const useCaptains = () => {
    const { data: captainsData, ...rest } = useCaptainsData();

    const transformedCaptains = useMemo(() => {
        return captainsData ? captainsData.docs.map((captain) =>
            transformCMSCaptainToAppCaptain(captain)
        ) : [];
    }, [captainsData]);

    return {
        ...rest,
        data: transformedCaptains,
    };
};